import { render, staticRenderFns } from "./wfh.vue?vue&type=template&id=efa032ec&scoped=true&"
var script = {}
import style0 from "./wfh.vue?vue&type=style&index=0&id=efa032ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa032ec",
  null
  
)

export default component.exports